import { FC, ReactNode } from "react";

export const TwoSideStat: FC<{
  homeColor: string;
  awayColor: string;
  leftValue: ReactNode;
  rightValue: ReactNode;
  bottomLabel: string;
}> = ({ homeColor, awayColor, leftValue, rightValue, bottomLabel }) => {
  return (
    <Wrap>
      <Split>
        <SideBox>
          <TopAccent accentColor={homeColor} />
          <Big>{leftValue}</Big>
        </SideBox>
        <Divider />
        <SideBox>
          <TopAccent accentColor={awayColor} />
          <Big>{rightValue}</Big>
        </SideBox>
      </Split>
      <BottomBar>{bottomLabel}</BottomBar>
    </Wrap>
  );
};

const Wrap = ({ children }: { children: ReactNode }) => (
  <div className="mx-auto mt-[8%] grid grid-rows-[auto_auto]">{children}</div>
);

const Split = ({ children }: { children: ReactNode }) => (
  <div className="grid grid-cols-[1fr_0.2vw_1fr] bg-black/80">{children}</div>
);

const SideBox = ({ children }: { children: ReactNode }) => (
  <div className="relative grid place-items-center p-[2vw]">{children}</div>
);

const Divider = () => <div className="h-full w-full bg-white" />;

const TopAccent = ({ accentColor }: { accentColor: string }) => (
  <div
    className="absolute left-0 right-0 top-0 h-[0.5vw] w-full"
    style={{ backgroundColor: accentColor }}
  />
);

const Big = ({ children }: { children: ReactNode }) => (
  <div className="text-[3vw] font-extrabold text-white">{children}</div>
);

const BottomBar = ({ children }: { children: ReactNode }) => (
  <div
    className="bg-white text-center font-extrabold text-black"
    style={{ fontSize: "clamp(10px, 1.3vw, 20px)", letterSpacing: "0.02em" }}
  >
    <div className="px-[1vw] py-[0.3vw]">{children}</div>
  </div>
);
